import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterData } from 'types/types';

export interface FiltersState {
  filters: (FilterData & { dashboardId: string })[]; // Include dashboardId in each filter
  registering: string[];
}

const initialState: FiltersState = {
  filters: [],
  registering: [],
};

const filtersSlice = createSlice({
  name: 'filtersState',
  initialState,
  reducers: {
    registerFilter: (
      state,
      action: PayloadAction<{
        dashboardId: string;
        filter: FilterData;
        loaded: boolean;
      }>
    ) => {
      const index = state.filters.findIndex(
        (f) =>
          f.filterId === action.payload.filter.filterId &&
          f.dashboardId === action.payload.dashboardId
      );
      if (index !== -1) {
        state.filters[index] = {
          ...state.filters[index],
          loaded: action.payload.loaded,
          selectedValues: action.payload.filter.selectedValues || [],
          values: action.payload.filter.values,
        };
      } else {
        state.filters.push({
          ...action.payload.filter,
          loaded: action.payload.loaded,
          dashboardId: action.payload.dashboardId,
        });
      }
    },
    registeringFilter: (state, action: PayloadAction<string>) => {
      state.registering.push(action.payload);
    },
    registeringFilterDone: (state, action: PayloadAction<string>) => {
      state.registering = state.registering.filter(
        (id) => id !== action.payload
      );
    },
    changeFilter: (
      state,
      action: PayloadAction<{
        dashboardId: string;
        filter: FilterData;
        selectedValues: any[];
        loaded: boolean;
      }>
    ) => {
      const index = state.filters.findIndex(
        (f) =>
          f.filterId === action.payload.filter.filterId &&
          f.dashboardId === action.payload.dashboardId
      );
      if (index !== -1) {
        state.filters[index] = {
          ...state.filters[index],
          selectedValues: action.payload.selectedValues,
          loaded: action.payload.loaded,
        };
      }
    },
    reloadFilters: (
      state,
      action: PayloadAction<{
        affectedFilters: any[];
        dashboardId: string;
        filterId: string;
        selectedValues: any[];
        loaded: boolean;
      }>
    ) => {
      state.filters.map((f) => {
        if (
          f.filterId === action.payload.filterId &&
          f.dashboardId === action.payload.dashboardId
        ) {
          f.selectedValues = action.payload.selectedValues;
        }
        if (
          action.payload.affectedFilters.includes(f.filterId) &&
          f.dashboardId === action.payload.dashboardId
        ) {
          f.loaded = action.payload.loaded;
        }
      });
    },
    changeFilterValues: (state, action) => {
      const filterIndex = state.filters.findIndex(
        (f) => f.filterId === action.payload.filterId
      );
      console.log(state.filters[filterIndex]);
      if (filterIndex > -1) {
        const value = state.filters[filterIndex].values?.find(
          (v) => v.name === action.payload.name
        )
        if(value){
          state.filters[filterIndex] = {
            ...state.filters[filterIndex],
            selectedValues: [value],
          };
        }
      }
    },
    removeDashboardFilters: (state, action: PayloadAction<string>) => {
      state.filters = state.filters.filter(
        (filter) => filter.dashboardId != action.payload
      );
    },
  },
});

// Adding the selector function to get filters based on dashboardId
export const getFiltersByDashboardId = (
  state: { filters: FiltersState },
  dashboardId: string
) => {
  return state.filters.filters.filter(
    (filter) => filter.dashboardId === dashboardId
  );
};

export const {
  registerFilter,
  registeringFilter,
  registeringFilterDone,
  changeFilter,
  reloadFilters,
  removeDashboardFilters,
  changeFilterValues
} = filtersSlice.actions;

export const filters = (state: { filters: FiltersState }) => {
  return state.filters.filters;
};

export const registering = (state: { filters: FiltersState }) => {
  return state.filters.registering;
};

export default filtersSlice.reducer;
